import React from "react";
import { useNavigate } from "react-router-dom";
import "./TermsAndConditions.css";
const TermsAndConditions = () => {
  const navigate = useNavigate();
  return (
    <div id="layout">
      <div className="TermsAndConditions_header">
        <h1 onClick={() => navigate(-1)}>
          <svg
            className="me-2"
            width="15"
            height="15"
            viewBox="0 0 13 13"
            fill="none"
          >
            <rect
              width="13"
              height="13"
              transform="matrix(-1 0 0 1 13 0)"
              fill="url(#pattern0)"
            />
            <defs>
              <pattern
                id="pattern0"
                patternContentUnits="objectBoundingBox"
                width="1"
                height="1"
              >
                <use
                  xlinkHref="#image0_1916_184"
                  transform="scale(0.00390625)"
                />
              </pattern>
              <image
                id="image0_1916_184"
                width="256"
                height="256"
                xlinkHref="data:image/png;base64,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"
              />
            </defs>
          </svg>
          Terms & Conditions
        </h1>
      </div>
      <div className="TermsAndConditions_content">
        <div>
          <h2>1. GENERAL/INTRODUCTION</h2>
          <p>
            DRCFO Advisory Services Pvt. Ltd. (hereinafter the “Company”, “we”,
            “us”, and “our” interchangeably) is a company duly incorporated in
            India under the provisions of the Companies Act, 2013 (as amended
            till date) and recognized as a startup by Department of Promotion of
            Industry and Internal Trade (DPIIT) bearing certificate no.
            DIPP56482. The company caters to the needs of patients by providing
            an integrated healthcare management system through its premium
            innovative solution under the flagship brand MY HEALTH VAULT. The MY
            HEALTH VAULT is a platform accessible on all internet-enabled
            electronic devices through software application (MY HEALTH VAULT )
            and/or website www.myhealthvaults .in (hereinafter “Application”
            which includes the website, software program, data and documentation
            related thereto) which provides services related to health data
            management and online appointments with a healthcare professional
            and other related services (collectively referred to as
            “Service(s)”) for integrated health care management for patients.
          </p>
        </div>
        <div>
          <h2>2. ENTIRE AGREEMENT</h2>
          <p>
            Users are advised to carefully go through these terms and conditions
            (“Terms of Use”), Terms & Conditions for Subscribed Users
            (“Subscriber Terms”) as applicable on the Healthcare professionals
            for a paid subscription, the Privacy Policy, and other supplementary
            policies and guidelines (“Other Terms”) collectively referred to as
            “Terms” as available on the Application before accessing the
            Application. <br /> These Terms together constitute a legally
            binding contract (“Agreement”) between you and our Company in
            connection with the use and/or access of Our Application. <br />{" "}
            This Agreement sets out the Terms under which the User(s)
            (hereinafter defined) is/are permitted to access and/or use the
            Application and the Service(s) available thereunder.
          </p>
        </div>
        <div>
          <h2>3. ACKNOWLEDGEMENT & ACCEPTANCE</h2>
          <p>
            3.1 These Terms set out Your rights and obligations regarding the
            download/use/access/browsing of the Application. The Terms must be
            read by You completely and well understood before agreeing to the
            said Terms which govern any or all relationship between You and the
            Company. <br /> 3.2 You understand and agree that these Terms shall
            be legally binding on You and agree that the Application along with
            the Service(s) offered by Us can be accessed only in accordance with
            these Terms, and You are obliged to comply with the Terms at all
            times. You are responsible to be aware of and agreeing to abide by
            the Terms as published and periodically modified by Us. We urge You
            to access, review and familiarize Yourself with these Terms
            periodically, for your continued use of Our Application. However, if
            You navigate away from the Application to a third-party website, You
            may be subject to alternative terms and conditions of use and
            privacy policy, as may be specified on such website. In such event,
            the terms and conditions of use and privacy policy applicable to
            that third party website shall govern Your use of that website.
            <br /> 3.3 We reserve our rights to update, change, edit, alter,
            amend, revise or substitute (collectively “Modifications”) the
            “Terms” from time to time. Any modifications made will be effective
            immediately upon them being made available on the Application and
            the date of the last modification will be notified on top of the
            page. You are advised to review these Terms periodically for any
            modifications. Your continued use of the Application consequent to
            any modifications shall be deemed acceptance of such modified terms
            and conditions. <br />
            3.4 You acknowledge that You will be bound by this Agreement for
            availing Service(s) through the Application offered by Us. If you do
            not agree with the Agreement or any part of the Agreement, please do
            not use the Application.
            <br /> 3.5 Your access and use of the Application will be solely at
            the discretion of Our Company.
            <br /> 3.6 The Company reserves the right to <br />
            (i) accept or reject the request of the User to create an account,
            <br />
            (ii) suspend the Account of User for a reason, <br />
            (iii) terminate the account of User for unauthorized use, or use in
            violation of the Terms <br />
            (iv) refuse the Service(s) offered through the Application due to
            non-availability of Service(s). <br />
            3.7 The Agreement is published in compliance of, and is governed by
            the provisions of Indian law, including but not limited to: <br />
            i. the Indian Contract Act, 1872, <br />
            ii. the (Indian) Information Technology Act, 2000, ( the “IT Act”);
            <br />
            iii. the rules, regulations, guidelines and clarifications framed
            thereunder, including the (Indian) Information Technology
            (Reasonable Security Practices and Procedures and Sensitive Personal
            Information) Rules, 2011 (the “SPI Rules”), and the (Indian)
            Information Technology (Intermediaries Guidelines) Rules, 2011 (the
            “IG Rules”); <br />
            iv. the Consumer Protection Act, 2019, and Consumer Protection
            (E-Commerce) Rules, 2020.
          </p>
        </div>
        <div>
          <h2>4. INTERPRETATION</h2>
          <p>
            In this Agreement,
            <br /> 4.1 The headings of Clauses are inserted solely for
            convenience of reference and are not intended as complete or
            accurate descriptions of content thereof and are not intended to
            describe, interpret, define or limit the scope, extent, or intent of
            these Terms. <br /> 4.2 The use of expressions “hereof”, “herein”,
            “hereto”, “hereunder” or similar expressions used in this Agreement
            mean and refer to this Agreement and not to any particular Clause of
            this Agreement. The terms “Clause” or “sub-clause” mean and refer to
            the Clause or sub-clause of this Agreement. <br /> 4.3 Any reference
            to any statute or statutory provision shall include:
            <br /> (i) all subordinate legislation made from time to time under
            that provision (whether or not amended, modified, re-enacted, or
            consolidated), and <br /> (ii) such provision as from time to time
            amended, modified, re-enacted or consolidated (whether before or
            after the date of this Agreement) to the extent such amendment,
            modification, re-enactment or consolidation applies or is capable of
            applying to any transactions entered into under this Agreement and
            (to the extent liability thereunder may exist or can arise) shall
            include any past statutory provision (as from time to time amended,
            modified, re-enacted or consolidated) which the provision referred
            to has directly or indirectly replaced.
            <br /> 4.4 No rule of construction or interpretation shall apply to
            the disadvantage or detriment of the Company for having control or
            being responsible for the preparation of this Agreement. <br /> 4.5
            The definitions shall have the same meaning regardless of whether
            they appear in singular or in the plural and shall be interpreted to
            be gender neutral.
          </p>
        </div>
        <div>
          <h2>5. DEFINITIONS</h2>
          <p>
            5.1 Ayush Practitioner: A healthcare professional specialised in
            Homeopath, Ayurveda, Naturopath, Unani and Siddha registered with
            the Ministry of AYUSH under the relevant law. <br /> 5.2 Clinic: A
            medical facility run by a single or group of Practitioners smaller
            than a hospital without in patient facility. Clinics generally
            provide only outpatient services and can have an observation bed for
            short stay.
            <br /> 5.3 Health record: A health record is a confidential
            compilation of pertinent facts, information, prescriptions,
            diagnostic reports of an individual's health history, including all
            past and present medical conditions, illnesses and treatments.{" "}
            <br />
            5.4 Medical Practitioner: is a person who is enrolled in the State
            Medical Register or the Indian Medical Register under the Indian
            Medical Council Act 1956.’ [IMC Act, 1956]. <br />
            5.5 Dentist: is a person who is enrolled in the State dental Council
            under the Indian Medical Council Act 1956.’ [IMC Act, 1956]. <br />
            5.6 Patient: A patient is any recipient of healthcare services that
            are performed/provided by Practitioner. <br />
            5.7 Practitioner: refers to a Healthcare Professional including
            Medical Practitioner or Ayush Practitioner or Clinic(s) wishing to
            be listed, or already listed, on the Application, including
            nominated, designated, authorized associates of such Practitioners.
            <br />
            5.8 Remote Consultation: Consultation taken from a Practitioner by a
            patient by use of electronic devices and communication technologies
            including and not limited to consultation over audio or video
            communication mode through internet.
            <br /> 5.9 Subscribed User: Subscribed User is a Practitioner. which
            includes Registered Medical Practitioner, Ayush Practitioner and/or
            a Clinic or similar institution run by the Practitioner. <br />
            5.10 Subscribed User Account: The Account created by a Patient to
            access the services of a Medical Practioner.
            <br /> 5.11 User: The User is a Patient or any other person
            accessing or visiting the Application and includes Subscribed
            User(s), as applicable.
            <br /> 5.12 User Account: The Account created by a User having
            option to obtain services as available from time to time on the
            Application, including to upload, modify, maintain records, book
            appointments, make payments. In case of Minor(s), the Account can be
            created by his/her Parent or legal Guardian and controlled by the
            Parent/Legal Guardian only.
          </p>
        </div>
        <div>
          <h2>6. NATURE AND APPLICABILITY OF TERMS</h2>
          <p>
            6.1 The Agreement applies to you whether you are - <br />
            i. A User of the Application (“You” or “User”), unless specified
            otherwise in specific clauses.
            <br /> ii. A Healthcare Professional including Medical practitioner
            or Ayush Practitioner or Clinic(s) or similar institution wishing to
            be listed, or already listed, on the Application, including
            nominated, designated, authorized associates of such Ppractitioners
            or institutions . <br />
            iii. A patient, his/her authorised representatives or legal
            guardians in case of minor(s) (“Patient” or “You” ).
            <br /> 6.2 This Agreement applies to the following services made
            available by the Company on the Application, which are offered to
            User including but not limited to: <br />
            i. For Patients: Facility to <br />
            (a) create, maintain, store and share health records subject to the
            data limit allowed by the Company from time to time,
            <br />
            (b) search for Practitioner using available filters such as name,
            specialty, and geographical area, or any other criteria that may be
            developed and made available on the Application from time to time,
            <br /> (c) schedule appointments with Practitioner and make payments
            for consultations and tele consultations <br />
            (d) set alarms and reminders, <br />
            (e) view data analysis of patient medical history, treatment and
            health records and <br />
            (f) remote consultation. <br />
            6.3 The Service(s) may change from time to time, at the sole
            discretion of the Company, and the Agreement applies to your use of
            the Application to avail the Service(s), as well as to all
            information provided by You on the Application at any given point in
            time. <br />
            6.4 Any person aged 18 years or above and capable of entering into a
            contract under the Indian Contract Act, 1872 is permitted to create/
            access User Account to avail the Service(s). Minors are prohibited
            from accessing or creating User Account; however Parent or Legal
            Guardian of the Minors can create a parent controlled User a Account
            to avail the Service(s) for Minors in accordance with applicable
            laws.
            <br /> 6.5 Services are available only for the citizens of India
            within the Territory of India.
          </p>
        </div>
        <div>
          <h2>7. USER ACCOUNT MANAGEMENT</h2>
          <p>
            7.1 You agree and acknowledge that You shall create only one User
            account and provide accurate, truthful, current and complete
            information including but not limited to (a) Name, (b) Age, (c)
            Gender, (d) valid email-Id and password when creating Your account
            and in availing all Service(s) on our Application. <br />
            7.2 The Company may subject to the Terms of this Agreement accept
            the User Account creation request. The creation of User Account
            shall be at the sole discretion of the Company. <br />
            7.3 You agree and acknowledge that you have carefully read the Terms
            before using or accessing the Application and/or creating a User
            Account on the Application and know how the information shared by
            You may be stored, protected, processed, used, shared and
            disseminated by the Company. <br />
            7.4 You shall be solely responsible to maintain and update Your
            account information and maintain the security of Your account by not
            sharing Your credentials with others and restricting unauthorized
            access. You can make changes to your User Account subject to the
            terms of this Agreement. <br />
            7.5 You are obligated to report to the Company immediately of any
            unauthorized access or suspicious activities in your User account
            and You are liable for all the activities that occur under Your
            account and accept all risk of unauthorized access. <br />
            7.6 In case of User Account registered for a minor Patient or a
            Patient not being able to operate his account, You ensure that in
            order to be authorized to access/use such User Account, You are
            either the Parent or the legal guardian or the person authorized by
            such Patient, as applicable. The Company has no liability on
            unauthorized access of User Accounts of Minor Patient or Patient not
            being able to operate his account using Your Password. You shall be
            solely responsible to keep Your password confidential and entrusting
            any person authorized to use Your Account. You can make changes in
            case of any discrepancies in your User Account information by
            reporting the same to the Company at the email address mentioned
            below. Notwithstanding the foregoing, the Company may reject the
            request of the User to edit, update or modify the User’s Account if
            such request is violative of applicable laws or in breach of thes
            <br /> 7.7 The Company reserves its right to terminate/suspend the
            User Account if a User furnishes false information or uses/accesses
            User Account in violation of the Terms or undertakes
            illegal/fraudulent activity through his User Account or without
            assigning any reason, with or without notice and to exercise any
            other remedy available under law. The termination of User Account
            shall be without prejudice to any rights which have already accrued
            to the Company.
          </p>
        </div>
        <div>
          <h2>8. SUBSCRIBED USER ACCOUNT</h2>
          <p>
            You, as A patient can avail Service(s) offered by Us through the
            Application by becoming a Subscribed User after payment of
            Subscriber Fees as per the Payment Plan. By subscribing to the
            Application, You, the patient agree and acknowledge that You shall
            abide by the Terms. You, the Patient , agree and acknowledge that
            you have carefully read the Terms before using or accessing the
            Application and/or creating a Subscribed User Account on the
            Application and know how the information shared by you may be
            stored, protected, processed, used, shared and disseminated by the
            Company.
          </p>
        </div>
        <div>
          <h2>9. CONDITIONS OF USE OF SERVICE(S):</h2>
          <p>
            9.1 CONSULTATION <br />
            i. Scheduling an appointment for consultation:
            <br /> -Patient can book an appointment for consultation with a
            Practitioner listed on the Application. <br />- Patient will receive
            a confirmation of appointment for the booked consultation through
            chosen method from the available options such as SMS/email/online
            communication or any other messaging service. <br />- Practitioner
            reserves the right to accept, reschedule or cancel an appointment in
            the case of non-availability. The time provided for consultation to
            User is indicative and actual consultation time may vary. Patient is
            advised to contact the Practitioner on the communication number
            provided for confirmation of the appointment in case of such
            cancellation/rescheduling. <br />- Consultation can be booked,
            rescheduled or cancelled free of cost up to fifteen minutes prior to
            the start of the appointment for Remote Consultation and up to
            thirty minutes prior to the start of the appointment for a physical
            visit based consultation, upto 2 times.
            <br /> - Rescheduling of a booked appointment is allowed not more
            than 2 times to the Patients and a fresh booking of the appointment
            is required. <br />
            ii. Remote consultation: <br />- User can have Remote Consultation
            recognized platforms as listed on the Application. User is to ensure
            all the connectivity requirements before the Remote Consultation and
            in case of any disconnections/errors etc. from User, the Company
            shall not be liable for rescheduling your appointment. However,
            Patient and/or Practitioner may contact each other for rescheduling
            on the same day. <br />- Remote Consultation via audio call or video
            call shall not include any physical examination. The medical opinion
            delivered by the Practitioner shall solely be based on the verbal
            communication between the concerned Practitioner and the Patient,
            and any test reports or medical history and other information shared
            by the Patient with the Practitioner through the Application. <br />
            - The Practitioner will prescribe medications or advise course of
            treatment on the basis of the data shared by the Patient including
            medical history, family history, existing medication and allergies
            if any. The Company or the Practitioner are not liable in case of
            any discrepancies in the data provided by the Patient and any
            consequences related thereto.
            <br /> - The Services are not meant in any way for emergency and
            life-threatening conditions. Patients are advised to consult their
            nearest available Practitioners as available for any such
            conditions. <br />
            iii. Other Guidelines
            <br /> - The User is obligated to observe all guidelines,
            precautions and protocols as laid down by the Central and State
            Government (“Mandatory Guidelines”) time to time in case of any
            Disasters, epidemics, pandemics or government declared emergency
            situation and the Company shall not be liable in case the User fails
            to comply with such Mandatory Guidelines.
            <br /> - In case of a physical consultation appointment, the
            Practitioner/Patient is obligated to inform the Company and Patient/
            Practitioner if he shows flu-like symptoms or any other communicable
            disease that is declared as a pandemic/epidemic and for which
            government has declared social distancing or quarantine even after
            the physical visit is confirmed and take consultation through Remote
            consultation only.
            <br />
            <br /> 9.2 HEALTH RECORD
            <br /> i. The Patient is provided with facility to upload, manage
            and share the medical records including past medical history,
            existing conditions, medications (if any), allergies (if any),
            physiological health data (eg. Height, weight, body measurements
            etc) and can use the facility free of cost upto the data limit
            allowed beyond which Service may be payable as updated on the
            Application from time to time. <br />
            ii. The Patient acknowledges and agrees that he is responsible for
            the accuracy of the data related to Health Record shared on the
            Application and the Company or the Practitioner are not responsible
            to verify the same. <br />
            iii. The Patient is allowed to amend, modify, revise or delete the
            data related to Health Record shared on the Application and once the
            changes are made, the Patient acknowledges and agrees that the
            previous data cannot be retrieved. It is sole responsibility of the
            Patient to maintain his User account and Health Record therein and
            avoid unauthorized access. <br />
            <br />
            9.3 ALARM & REMINDER <br />
            i. The User can set alarms and reminders on the Application as per
            his convenience including reminders for scheduled appointments,
            medicines, temperature/blood pressure/blood sugar/O2 measurements.
            <br /> ii. Automatic alarms and reminders shall be set for a User
            once an appointment is booked using the Application;
            <br /> iii. User is responsible at all times to keep the Application
            functional by staying connected to internet for the feature of
            alarms/reminder to work at all times. The Company shall not be held
            liable for any consequence or loss in case the alarms/reminders are
            not functional due to non-connectivity with the internet or due to
            any other reason.
            <br />
            <br /> 9.4 DATA ANALYTICS <br />
            i. Patient can choose from the available options and create/view the
            analysis of his medical history/data and share the same with
            Practitioner or store it on Application or download for his own use.
            <br />
            ii. User acknowledges and agrees that the data analytics reports
            generated on the Application are for information purpose only and
            the same cannot be used for medico-legal or legal purposes and there
            may be scope of error due to use of artificial intelligence/computer
            software/algorithms etc.
            <br />
            <br /> 9.5 THIRD PARTY SCHEMES <br />
            User acknowledges and agrees that the services through the
            Application are solely provided under the Terms of this Agreement
            and no benefits/exemption can be availed with/under any third party
            insurance/scheme provided by private/government agencies. <br />
            <br />
            9.6 FEEDBACK <br />
            i. User can review the Practitioner after consultation subject to
            content related restrictions mentioned under Clause 11 of the Terms
            and Clause ___Privacy Policy.
            <br />
            ii. The Company reserves all the rights to moderate/remove any
            comments, reviews which are considered inappropriate in the sole
            discretion of the Company. <br />
            <br />
            9.7 OTHER ADDITIONAL FEATURES <br />
            There may be additional features launched time to time basis which
            shall be governed under this Agreement even if not specifically
            mentioned.
          </p>
        </div>
        <div>
          <h2>10. GENERAL OBLIGATIONS</h2>
          <p>
            10.1 Accessing (or attempting to access) the Application or any part
            thereof by any means other than through the means we provide, is
            strictly prohibited. You specifically agree not to access (or
            attempt to access) the Application or any part thereof through any
            automated, unethical or unconventional means.
            <br /> 10.2 Engaging in any activity that disrupts or interferes
            with the Application, including the servers and/or networks on which
            our Application is located or connected to, is strictly prohibited.
            <br /> 10.3 Attempting to copy, duplicate, reproduce, sell, trade,
            or resell our Application is strictly prohibited. <br />
            10.4 The User is solely responsible for any consequences, losses, or
            damages that may directly or indirectly incur or suffer due to any
            unauthorized activities conducted by the User, as explained above,
            and may incur criminal or civil liability. <br />
            10.5 The Company may provide various open communication tools on the
            Application such as reviews which are subject to this Agreement. You
            understand that generally we do not pre-screen or monitor the
            content posted by users of these various communication tools, which
            means that if you choose to use these tools to submit any type of
            content to our Application, then it is your personal responsibility
            to use these tools in a responsible and ethical manner. By posting
            information or otherwise using any open communication tools as
            mentioned, You agree that You will not upload, post, share, or
            otherwise distribute any content that: <br />
            i. is illegal, threatening, defamatory, abusive, harassing,
            degrading, intimidating, fraudulent, deceptive, invasive, racist, or
            contains any type of suggestive, inappropriate, or explicit
            language; <br />
            ii. infringes on any trademark, patent, trade secret, copyright, or
            other proprietary right of any party; <br />
            iii. contains any type of unauthorized or unsolicited advertising;
            <br /> iv. impersonates any user or entity, including any Company
            employees or representatives. <br />
            10.6 The Company has the right at its sole discretion to remove any
            content that it feels in its judgment that does not comply with this
            Agreement, along with any content that it feels is otherwise
            offensive, harmful, objectionable, inaccurate, or violates any third
            party intellectual property rights. The Company is not responsible
            for any delay or failure in removing such content. If you post
            content that we choose to remove, you hereby consent to such
            removal, and consent to waive any claim against us. <br />
            10.7 The Company do not assume any liability for any content posted
            by you or any other third party users of our Application. However,
            any content posted by you using any open communication tools on the
            Application, provided that it doesn't violate or infringe on any
            third party intellectual property rights becomes the property of the
            Company, and as such, gives us a perpetual, irrevocable, worldwide,
            royalty-free, exclusive license to reproduce, modify, adapt,
            translate, publish, publicly display and/or distribute as we see
            fit. This only refers and applies to content posted via open
            communication tools as described and does not refer to information
            that is provided for availing the Services necessary in order to use
            the Application. All information provided to avail our Services is
            covered by our Privacy Policy. <br /> 10.8 The Company is not
            obliged to keep/main back up copy of any data or information of
            User.
          </p>
        </div>
        <div>
          <h2>11. PAYMENTS</h2>
          <p>
            11.1 The Company does not charge any fee from Patient for User
            Account registration or for using/ browsing/accessing the
            Application. However, the Company reserves the right to charge a fee
            for any or all of its Service(s) at any point of time. <br /> 11.2
            The limited space available to a Patient for Health Record
            Management is free upto the data limit provided in the Application
            50MB and shall be chargeable as per the Ppayment Pplan available in
            the User Account once the free data limit of 50 MB is exhausted.
            <br />
            11.3 Patient agrees and acknowledges that he shall make payments as
            applicable for the Services as displayed on the Application at the
            time of availing the Services. <br />
            11.4 Patient agrees and acknowledges to make payment to the
            Practitioner for Consultation as per the Fee displayed on the
            Application by any of the payment modes available on the
            Application.
            <br /> 11.5 Patient agrees and acknowledges that he shall not hold
            the Company responsible for any loss/damage caused to him by any
            act/ omission on part of the Practitioner or any third party beyond
            the control of the Company. The Patient agrees and acknowledges that
            he is availing the Services on the Application at his own risk.
            <br />
            11.6 Patient are solely responsible for payment of all taxes, legal
            compliances and statutory registrations. The Company is only
            responsible for its own tax compliances. <br />
            11.7 In order to process the payments, the Company may require
            details of Patient’s financial credentials which shall be
            used/accessed/stored as per the Privacy Policy. <br />
            11.8 Patient agrees and acknowledges that no refund shall be
            provided for any Service already availed by the Patient including in
            case of no show for consultation for which payment that has already
            been made. However, if the Patient wishes to cancel or reschedule
            the appointment, he is free to do so and the payment if already
            collected shall be refunded within 3-5 working days of such
            cancellation subject to deduction of cancellation charges, if any.
            <br /> 11.9 In the event of non-availability of the Practitioner for
            the consultation as per the appointment due to any reason, <br />-
            the Patient has option to reschedule the appointment subject to
            verification of the non-availability of Practitioner by the Company,
            <br />- the Patient has option to cancel the appointment and write
            to the Company within five (5) days from the occurrence of such
            event; in which case, the consultation fee will be refunded to the
            Patient within the next five (5) to six (6) business days subject to
            deduction of any cancellation charges.
            <br /> 11.10 Patient will not be entitled for any refund in a case
            where, the Practitioner is unable to meet the User at the exact time
            of the scheduled appointment time and the Patient is required to
            wait, irrespective of the fact whether the Patient is required to
            wait or choose to not obtain the medical services from the said
            Practitioner.
          </p>
        </div>
        <div>
          <h2>12. INTELLECTUAL PROPERTY</h2>
          <p>
            The Company owns its respective Intellectual Properties, without
            conferring any interests therein on the User. Without limiting the
            generality of the preceding sentence, User shall not acquire any
            right, title or interest in the Company’s Intellectual Property by
            virtue of this Agreement or otherwise. Any use of the Company’s
            Intellectual Property without the prior written consent of the
            Company is strictly prohibited. In the event of any unauthorized use
            of the Company’s intellectual property, the Company reserves its
            rights to initiate such legal actions as warranted under law.
          </p>
        </div>
        <div>
          <h2>13. REPRESENTATION AND WARRANTIES</h2>
          <p>
            13.1 User(s) hereby represents and warrants to the Company that:
            <br />
            i. he is competent to contract under Indian Contract Act, 1872,
            <br />
            ii. the Information given by him to the Company, on this Application
            is accurate, true and nothing material is concealed by him, <br />
            iii. he is the Legal Guardian of the minor or person of unsound mind
            on whose behalf the User Account is created (applicable only in case
            of Services being availed for Minors or people suffering from
            unsound mind), <br /> iv. he is authorized to use a User Account of
            a person who is not able to access his/her User Account, <br />
            v. the Agreement constitutes a valid and binding obligation
            enforceable against him in accordance with its terms, <br />
            vi. the acceptance by him, the performance by him of the obligations
            hereunder and compliance by him with the provisions hereof will not
            violate, contravene or breach or create a default under any
            agreement, instrument, charter or by-law provision, statute,
            regulation, judgment, ordinance, decree, writ, injunction or
            applicable laws, <br />
            vii. there are no claims, actions, proceedings, which are initiated,
            alleged, threatened or pending against him which would restrict him
            from accessing and availing any Services on the Application, <br />
            viii. he will not initiate or carry out any transaction on this
            Application on behalf of any other party, unless he is specifically
            authorized to do so, <br /> ix. he shall comply with all applicable
            laws, <br /> x. he shall not infringe the Intellectual Property
            Rights of the Company, <br />
            xi. he/she will not use the User Account or Subscribed User Account
            for unlawful or unauthorized purposes, <br /> xii. he will not
            upload any obscene or objectional content on the Application, <br />{" "}
            xiii. appropriate action can be initiated against him as warranted
            under the circumstances, for unauthorized use or breach of Terms of
            the Agreement.
          </p>
        </div>
        <div>
          <h2>14. LIMITATION OF LIABILITIES/ INDEMNIFICATION</h2>
          <p>
            14.1 User agrees to indemnify and hold harmless the Company, its
            affiliates, and their directors, officers, managers, employees,
            donors, agents, and licensors, from and against all losses,
            expenses, damages and costs, including reasonable attorneys' fees,
            resulting from any violation of this Agreement or the failure to
            fulfil any obligations relating to your account incurred by You or
            any other user using your account. Company reserves the right to
            take over the exclusive defence of any claim for which it is
            entitled to indemnification under this Agreement. In such an event,
            you shall provide us with such cooperation as is reasonably
            requested by us. <br />
            14.2 User agrees and acknowledges that the Company or any of its
            directors, officers, employees, agents or content or service
            providers shall not be liable for any direct, indirect, special,
            incidental, consequential, exemplary or punitive damages arising
            from, or directly or indirectly related to, the use of, or the
            inability to use, the Application or the content, materials and
            functions related thereto, the Services, , lost business or lost
            Users. In no event shall the Company or any of its directors,
            officers, employees, agents or content or service providers be
            liable for: <br />
            i. provision of or failure to provide all or any service by
            Practitioners to Users contacted or managed through the Application;
            <br />
            ii. any content posted, transmitted, exchanged or received by or on
            behalf of any User or other person on or through the Application;
            <br />
            iii. any unauthorized access to or alteration of your transmissions
            or data; or <br />
            iv. any other matter relating to the Application. <br />
            14.3 DISCLAIMER <br />
            Without prejudice to the generality of the above, Company is not
            involved in providing any healthcare or medical advice or diagnosis
            and hence is not responsible for any interactions between Patient
            and the Practitioner. Patient understands and agrees that Company
            will not be liable for: <br />
            i. Patient interactions and associated issues Patient has with the
            Practitioner;
            <br /> ii. the ability or intent of the Practitioner(s) or the lack
            of it, in fulfilling their obligations towards Patient; <br />
            iii. any wrong medication or quality of treatment being given by the
            Practitioner(s), or any medical negligence on part of the
            Practitioner(s); <br />
            iv. inappropriate treatment, or similar difficulties or any type of
            inconvenience suffered by the Patient due to a failure on the part
            of the Practitioner to provide agreed Services;
            <br /> v. any misconduct or inappropriate behavior by the
            Practitioner; <br />
            vi. Notwithstanding Clause 12, cancellation or no show by the
            Practitioner or rescheduling of booked appointment or any variation
            in the fees charged by the Practitioner.
          </p>
        </div>
        <div>
          <h2>15. FORCE MAJEURE</h2>
          <p>
            You accept and acknowledge that the Company shall not be liable for
            any loss or damage caused to the User as a result of delay or
            default or deficiency or failure in the Services as a result any act
            of God, governmental act, act of any regulatory authority,
            supervening illegality, war, malicious damage, fire, flood,
            epidemics, pandemic(s), including but not limited to coronavirus
            (COVID-19) or any other health risk outbreaks, explosion, power
            blackout, breakdown of any equipment, loss of utility, civil
            commotion, industrial dispute, acts or omissions of
            telecommunications or data communications operators or carriers or
            of any other third parties or, in relation to the Services any
            technical or other problems affecting any operation of the Services,
            or any other delay or default or deficiency or failure which arises
            from causes beyond the Company’s reasonable control (“Force Majeure
            Event”). In the event of any Force Majeure Event arising, the
            Company, depending on whose performance has been impacted under the
            Terms, shall promptly give You notice of the facts which constitute
            the Force Majeure Event.
          </p>
        </div>
        <div>
          <h2>16. GOVERNING LAW AND DISPUTE RESOLUTION</h2>
          <p>
            16.1 Any and all dispute/differences arising from and in connection
            to this contract between the parties including its interpretation,
            adjudication of its validity, termination or breach of contract, the
            aggrieved party shall notify the other of the dispute within a
            period of 30 days in writing. The parties shall attempt to reach an
            amicable solution by mutual discussions within 60 days of receipt of
            the notice. <br />
            16.2 If the parties fail to resolve the dispute through mutual
            discussions as per Section 18.1, the dispute shall be mandatorily
            referred to Arbitration under the Arbitration and Conciliation Act,
            1996 as amended till date including the rules framed thereunder.
            <br />
            16.3 Each party shall within 7(seven) days of referral of matter to
            arbitration, appoint one arbitrator. The two arbitrators shall with
            mutual consent appoint a third arbitrator within 15 (fifteen) days
            from the date of their appointment. <br />
            16.4 The Arbitration proceedings shall be conducted in English and
            the Arbitral Award shall be in English. The decision of the Arbitral
            Tribunal shall be final and binding on both parties. <br />
            16.5 The seat and venue of the Arbitration shall be Lucknow. <br />
            16.6 The Courts of Lucknow shall have exclusive jurisdiction for any
            applications arising out of or in connection with the Arbitration
            including application for interim relief sought by parties. <br />
            16.7 Each Party shall bear the cost of preparing and presenting its
            case, and the cost of arbitration, including fees and expenses of
            the arbitrators shall be shared equally by the Parties unless the
            award otherwise provides. The arbitration proceedings, including any
            outcome, shall be confidential.
            <br /> 16.8 The Agreement will be governed by Laws of India, as
            applicable.
          </p>
        </div>
        <div>
          <h2>17. MISCELLANEOUS</h2>
          <p>
            19.1 SURVIVAL: Even after termination, certain obligations mentioned
            under Covenants, Liability, Indemnity, Intellectual Property,
            Dispute Resolution will continue and survive termination. <br />
            19.2 SEVERABILITY: If any provision of these Terms is deemed
            invalid, unlawful, void or for any other reason unenforceable, then
            that provision shall be deemed severable from these Terms and shall
            not affect the validity and enforceability of any of the remaining
            provisions.
            <br /> 19.3 WAIVER: No provision of these Terms shall be deemed to
            be waived and no breach excused, unless such waiver or consent shall
            be in writing and signed by the Company. Any consent by the Company
            to, or a waiver by the Company of any breach by You, whether
            expressed or implied, shall not constitute consent to, waiver of, or
            excuse for any other different or subsequent breach.
          </p>
        </div>
        <div>
          <h2>18. GRIEVANCE REDRESSAL</h2>
          <p>
            To report any grievance with respect to the Application, including
            any discrepancies and grievances with respect to processing of
            information, you can contact our Grievance Officer at: <br />
            Name: CA AKHIL KUMAR <br />
            Address: CHIEF EXECUTIVE OFFICER
            <br /> Phone:91-95699-29525
            <br /> Email: akhil@drcfo.in
          </p>
        </div>
        <div>
          <h2>19. CONTACT INFORMATION</h2>
          <p>
            If you have any questions concerning the Company, the Application,
            the Terms, this Agreement, the Services, or anything related to any
            of the foregoing, or you wish to give your comments/feedback, You
            can reach us at the following email address mentioned below or using
            the Contact Us option in the Application.
            <br /> Unless otherwise specified herein, all notices or other
            communications under or in connection with this Agreement shall be
            given in writing and may be sent by personal delivery or post
            acknowledgment due or courier (with POD) or E-mail as mentioned
            below. Any such notice or other communication will be deemed to be
            effective if sent by personal delivery, (when delivered) if sent by
            registered post (ack due) (on actual receipt), and if sent by
            courier (on actual receipt), and if sent by E-mail, (on receipt of a
            confirmation to the correct Email id).
            <br /> Name: CA AKHIL KUMAR
            <br /> Designation: CHIEF EXECUTIVE OFFICER <br />
            Address: C-5 K K APPARTEMENT , OPPOSITE NARMADA BHAWAN, DALI BAGH,
            LUCKNOW-226001
            <br /> Email ID: akhil@drcfo.in
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
